import React from "react";
import {
  GraduationCap, ShoppingCart, Bus, Ticket, Utensils, House,
  Store, Wrench, UsersRound, Church, Building2, ContactRound,
  ChartNoAxesColumnIncreasing, Gift,
} from "lucide-react";
import "./StartupLoader.css";

const MODULES = [
  { label: "Students", Icon: GraduationCap, color: "#0878e8" },
  { label: "Transport", Icon: Bus, color: "#ef6a12" },
  { label: "Events & ticketing", Icon: Ticket, color: "#9425d7" },
  { label: "Food vendors", Icon: Utensils, color: "#0b9b55" },
  { label: "Hostels", Icon: House, color: "#e91e63" },
  { label: "Merchants", Icon: Store, color: "#c88700" },
  { label: "Service providers", Icon: Wrench, color: "#00a99a" },
  { label: "Employees", Icon: UsersRound, color: "#1768db" },
  { label: "Churches", Icon: Church, color: "#7b28cc" },
  { label: "Businesses", Icon: Building2, color: "#e3315d" },
  { label: "Smart identity", Icon: ContactRound, color: "#0b9b55" },
  { label: "Attendance", Icon: ChartNoAxesColumnIncreasing, color: "#1768db" },
  { label: "Gift cards", Icon: Gift, color: "#d09208" },
  { label: "Customers", Icon: ShoppingCart, color: "#e52354" },
];

/** Full-screen loader reserved for platform startup and saved-session restoration. */
export default function StartupLoader({ error, onRetry, retrying = false, fadeOut = false }) {
  return (
    <main className={`icaard-startup${fadeOut ? " icaard-startup--fade-out" : ""}`} role={error ? "alert" : "status"} aria-live="polite" aria-busy={!error}>
      <div className="icaard-startup__ambient" aria-hidden="true" />
      <div className="icaard-startup__stage">
        <div className="icaard-startup__orbit" aria-hidden="true">
          <div className="icaard-startup__ring icaard-startup__ring--outer" />
          <div className="icaard-startup__ring icaard-startup__ring--inner" />
          <div className="icaard-startup__track">
            {MODULES.map(({ label, Icon, color }, index) => {
              const angle = (360 / MODULES.length) * index - 90;
              return (
                <div
                  className="icaard-startup__node"
                  key={label}
                  style={{ "--orbit-angle": `${angle}deg`, "--counter-angle": `${-angle}deg`, "--module-color": color }}
                >
                  <div className="icaard-startup__module">
                    <span className="icaard-startup__icon"><Icon size={19} strokeWidth={2.15} /></span>
                    <span className="icaard-startup__label">{label}</span>
                  </div>
                </div>
              );
            })}
            <span className="icaard-startup__particle icaard-startup__particle--one" />
            <span className="icaard-startup__particle icaard-startup__particle--two" />
            <span className="icaard-startup__particle icaard-startup__particle--three" />
          </div>
        </div>
        <div className="icaard-startup__center">
          <img className="icaard-startup__logo" src="/icaard-logo-transparent.png" alt="i-Caard" />
          <div className="icaard-startup__progress" aria-hidden="true"><span /></div>
        </div>
      </div>
      <p className="icaard-startup__message">{error ? "We couldn’t finish starting i-Caard." : "Bringing everything together…"}</p>
      {error && (
        <>
          <p className="icaard-startup__hint">Check your connection, then try again. Your saved sign-in is still here.</p>
          <button className="icaard-startup__retry" onClick={onRetry} disabled={retrying}>
            {retrying ? "Trying again…" : "Retry"}
          </button>
        </>
      )}
    </main>
  );
}
